/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';
import type { ICollectionCredit } from './person-credit-schema';
import { collectionCreditSchema } from './person-credit-schema';

export const collectionCreditsResponseSchema = createApiResponseSchema(
  z.array(collectionCreditSchema),
) as import('zod').ZodSchema<IAPI<ICollectionCredit[]>>;

export type ICollectionCreditsResponse = IAPI<ICollectionCredit[]>;
